module.exports = "<p>\r\n  bloqueos works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/bloqueos/bloqueos.component.html
// module id = ../../../../../src/app/components/bloqueos/bloqueos.component.html
// module chunks = main